import React from 'react';
import { Button } from '~/shared/Theme';
import { Caption } from '~/shared/Typography';

const ResendCodeButton = React.memo(({
    countdown,
    disabled,
    handleResendCode,
    isResendCode,
    buttonTextColor,
    t,
}: {
    countdown: number;
    disabled: boolean;
    handleResendCode: () => void;
    isResendCode: boolean;
    buttonTextColor: string;
    t: (key: string, values?: any[]) => string;
}) => {
    return (
        <Button
            disabled={disabled}
            onPress={handleResendCode}
            px={4}
            py={2}
            textAlign={'center'}
        >
            <Caption
                fontFamily={'Helvetica'}
                color={buttonTextColor}
            >
                { disabled && countdown !== 0
                    ? t('loginTemplate.resend_code_countdown', [countdown])
                    : isResendCode ? t('loginTemplate.resend_code') : t('loginTemplate.resend_code_cta')
                }
            </Caption>
        </Button>
    );
});

ResendCodeButton.displayName = 'ResendCodeButton';


export default ResendCodeButton;
